// @flow
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router';

// Actions
import { goTo } from 'store/reducers/navigation/actions';
import {
  setMileage,
  setLicenseNumber,
  setCarColor
} from 'store/reducers/selfCheckIn/actions';
import {
  gtmUserEventMileageEntered,
  gtmUserEventLicensePlateEntered,
  gtmUserEventColorEntered
} from 'store/reducers/gtm/actions';

// Component
import MileagePage from './MileagePage';

// Selectors
import { getMileage } from 'store/reducers/appointment/selectors';
import {
  getSelfCheckinMileage,
  getSelfCheckInLicenseNumber,
  getSelfCheckInCarColor
} from 'store/reducers/selfCheckIn/selectors';
import { showSCIProgressBar } from 'store/reducers/optimizelyABTest/selectors';

const mapStateToProps = state => ({
  mileage: getMileage(state),
  licenseNumber: getSelfCheckInLicenseNumber(state),
  selfCheckinMileage: getSelfCheckinMileage(state),
  carColor: getSelfCheckInCarColor(state),
  showSCIProgressBar: showSCIProgressBar(state)
});

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      setMileage,
      gtmUserEventMileageEntered,
      gtmUserEventLicensePlateEntered,
      gtmUserEventColorEntered,
      setLicenseNumber,
      setCarColor,
      goTo
    },
    dispatch
  );

export default compose(
  withRouter,
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(MileagePage);



// WEBPACK FOOTER //
// ./src/components/pages/SelfCheckIn/MileagePage/MileagePageContainer.js